/* eslint-disable  */
import { IconButton } from "@material-ui/core";
import { ShoppingBasketOutlined } from "@material-ui/icons";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { productActionCreators, userDataActionCreators } from "../../../../service/action-creators";
import { GetUserProfile } from "../../../../service/action-creators/authAction";
import { GetNotifications } from "../../../../service/action-creators/notificationAction";
import Loader from "../../../Loader";
import RenderHome from "../../home/RenderHome";
import "./SearchedProduct.css";
import AddToCartModal from "./sub_component/AddToCartModal";

function SearchedProduct() {
  const dispatch = useDispatch();
  const history = useHistory();
  const {  GetFeaturedProduct , SearchProducts, ResetProductResponse} = bindActionCreators(
    productActionCreators,
    dispatch
  );
  const { AddProductToCart, ResetUserDataResponse, GetCartProducts} = bindActionCreators(
    userDataActionCreators,
    dispatch
  );

  const product = useSelector((state) => state?.product);
  const userData = useSelector((state) => state?.user);
  // const isLoading = product?.isLoading;

  const {products, isLoading, paginate, response} = product
 
  
  // const electronicsCategory = product?.electronicsCategory;
  // const products = product?.products;
//   console.log("latestCategory", latestCategory);
  const [search, setSearch] = useState(null);
  // the term the results on screen actually belong to
  const [searchValue, setSearchValue] = useState(history.location.state?.searchValue);
  const [cartModalProduct, setCartModalProduct] = useState(null);
  const carts = userData?.cart;

  const [pageCount, setPageCount] = useState(0);
  const itemsPerPage = 15;
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    setPageCount(Number(paginate?.total) || 0);
  }, [paginate?.total]);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    SearchProducts(searchValue, true, event.selected + 1, itemsPerPage);
  };

  console.log('history', history)

//   const searchValuePassed = history.location.state.searchValue
//   console.log('searchValuePassed', searchValuePassed)

  useEffect(() => {
    // GetLatestCategory("Latest Products");
    GetFeaturedProduct();
   dispatch(GetUserProfile())
   dispatch(GetNotifications())
   GetCartProducts()
    
  }, []);

  useEffect(() => {
    if (!searchValue) return;
    setCurrentPage(0);
    SearchProducts(searchValue, true, 1, itemsPerPage);
  }, [searchValue])

  console.log('products', products)

//   useEffect(() => {
//     setSearchValue(null)
//   }, [])

  const handleSearchButton = (e) => {
    e.preventDefault()
    if (search) {
      // make the typed term the active one so pagination queries the same term
      setCurrentPage(0);
      if (search === searchValue) {
        SearchProducts(search, true, 1, itemsPerPage);
      } else {
        setSearchValue(search);
      }
    } else {
        GetFeaturedProduct();
      //call your existing data
    }
  };

  const handleAddToBasket = (e, product) => {
    e.preventDefault();
    e.stopPropagation();
    setCartModalProduct(product);
  };

  const handleModalAdd = (payload) => {
    dispatch(AddProductToCart(payload));
  };

  const onSearchProduct = debounce((e) => {
    if (e?.target?.value) {
      setSearch(e?.target?.value ?? null);
    } else {
      setSearch(null);
      // GetBusiness(true, 1, 12);
      GetFeaturedProduct();
    }
  }, 800);

  console.log("search", search);

  useEffect(() => {
    if (response?.state === "SUCCESS" || userData?.response?.state === "SUCCESS") {
      // toast.success(response?.message);
      GetCartProducts();
      setTimeout(() => {
        ResetUserDataResponse();
        ResetProductResponse()
      }, 1500);
    } else if (response?.state === "ERROR" || userData?.response?.state === "ERROR") {
      // toast.error(response?.message);
      setTimeout(() => {
        ResetUserDataResponse();
        ResetProductResponse()
      }, 1500);
    }
  }, [response?.state || userData.response.state]);

  return (
    <div className="SearchedProduct">
      <RenderHome>
        {(isLoading || userData?.isLoading) && <Loader />}

        {/* Back + Search Bar */}
        <button className="backBtn" onClick={() => history.goBack()}>← Back</button>
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="searchContainer">
            <div className="search">
              <input
                type="search"
                placeholder="Search for your product here..."
                name="search"
                defaultValue={search}
                onChange={(e) => onSearchProduct(e)}
              />
            </div>
            {search && (
              <button type="button" className="button" onClick={handleSearchButton}>
                Search
              </button>
            )}
          </div>
        </form>

        {/* Results */}
        {!isLoading && products?.length === 0 && currentPage === 0 && (
          <div className="searchNotFound">
            <div className="searchNotFound-icon">🔍</div>
            <h3 className="searchNotFound-title">No products found</h3>
            <p className="searchNotFound-sub">
              We couldn't find any results for <strong>"{searchValue}"</strong>. Try a different keyword.
            </p>
          </div>
        )}
        <div className="searchedContainer">
          {products?.map((product, index) => (
            <div className="ProductCard" key={index}>
              <div
                className="productImage"
                onClick={() => history.push({ pathname: "/product-detailed", state: { product } })}
              >
                <img className="image" src={product?.images[0]?.url} alt="product" />
              </div>
              <div
                className="productDetailes"
                onClick={() => history.push({ pathname: "/product-detailed", state: { product } })}
              >
                <h3>
                  {product?.product_name?.length > 50
                    ? product?.product_name.slice(0, 50) + "..."
                    : product?.product_name}
                </h3>
              </div>
              <div className="ProductPrice">
                <div className="priceContent">
                  <h3>
                    &#8373;{product?.new_price}
                    {product?.old_price && <small> &#8373;{product?.old_price}</small>}
                  </h3>
                  <div
                    className="addToCatBtn"
                    onClick={(e) => handleAddToBasket(e, product)}
                  >
                    <ShoppingBasketOutlined style={{ fontSize: "1.1rem" }} />
                  </div>
                </div>
                {product?.percent > 0 && (
                  <div className="addFavourite">{product?.percent}% off</div>
                )}
              </div>
            </div>
          ))}
        </div>
          {pageCount > 1 && (
                <ReactPaginate
                  breakLabel="•••"
                  nextLabel={<span className="nav-arrow">→</span>}
                  onPageChange={handlePageClick}
                  forcePage={currentPage}
                  pageRangeDisplayed={5}
                  pageCount={pageCount}
                  previousLabel={<span className="nav-arrow">←</span>}
                  renderOnZeroPageCount={null}
                  containerClassName="pagination"
                  pageLinkClassName="page-num"
                  previousClassName="page-nav"
                  nextClassName="page-nav"
                  previousLinkClassName="page-num page-nav-btn"
                  nextLinkClassName="page-num page-nav-btn"
                  activeLinkClassName="active"
                  disabledClassName="disabled"
                />
              )}

        {cartModalProduct && (
          <AddToCartModal
            product={cartModalProduct}
            carts={carts}
            onAdd={handleModalAdd}
            onClose={() => setCartModalProduct(null)}
          />
        )}
      </RenderHome>
    </div>
  );
}

export default SearchedProduct;
